import { Flex, Link, Text } from '@chakra-ui/react';
import { EColor, ETextVariant, ResponsiveContainer } from '@pwcc/common-components';

import { MONOLITH_BASE_URL } from '../config/env';
import { FanaticsCollectLogo } from '../icons/FanaticsCollect';

const CUSTOMER_SUPPORT_URL = 'mailto:cs@fanaticscollect.com';

const UnavailablePage = () => {
  return (
    <ResponsiveContainer>
      <Flex alignItems="flex-start" width="100%" my="12px">
        <FanaticsCollectLogo color={'#282828'} height={{ base: '26px', lg: '38px' }} width="auto" />
      </Flex>
      <Flex
        my={{ base: '48px', md: '72px' }}
        flexDir="column"
        width="100%"
        alignItems={{ base: 'flex-start', md: 'center' }}
      >
        <Text variant={ETextVariant.Heading1}>We&apos;ve moved things around.</Text>
        <Text variant={ETextVariant.Paragraph2} my={{ base: '24px', md: '24px' }}>
          External login is no longer available. Please log in at{' '}
          <Link color={EColor.DarkBlue} href={MONOLITH_BASE_URL}>
            {MONOLITH_BASE_URL}
          </Link>{' '}
          or contact us at{' '}
          <Link color={EColor.DarkBlue} href={CUSTOMER_SUPPORT_URL} type="email">
            cs@fanaticscollect.com
          </Link>
        </Text>
      </Flex>
    </ResponsiveContainer>
  );
};

export default UnavailablePage;
